module.exports = __webpack_public_path__ + "static/media/logo.210fc5ea.svg";